module.exports = __webpack_public_path__ + "img/KJ.2791d2c7.png";